import type { TechnologySetupKeys } from '@/core/config/technologies'
import { fetchText } from '@/core/utils/fetch'

import { buildUrl, type GatewayConfig } from './libraries.api'

export const fetchSetupCommands = async (
  config: GatewayConfig,
  packageManagers: TechnologySetupKeys[]
): Promise<Record<string, Record<string, string>>> => {
  const baseUrl = buildUrl(config)

  const results = await Promise.allSettled(
    packageManagers.map(async (technology) => {
      const template = (await fetchText(`${baseUrl}/${technology.path}`)).trim()
      if (!template) {
        throw new Error(`Empty setup command from /${technology.path}`)
      }

      return { technology, template }
    })
  )

  return results.reduce<Record<string, Record<string, string>>>((acc, result) => {
    if (result.status !== 'fulfilled') {
      return acc
    }

    const { technology, template } = result.value
    acc[technology.id] = { [technology.label]: template }
    return acc
  }, {})
}
